import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'hero-confirm',
  template: `
    <div class="overlay-background">
      <div class="wrapper">
        <div class="hero-confirm">
          <div class="content">
            <ng-content></ng-content>
          </div>
          <div class="actions">
            <button class="btn btn-hero btn-hero-primary btn-small" (click)="accept.emit()">Accept</button>
            <button class="btn btn-hero btn-hero-secondary btn-small" (click)="deny.emit()">Cancel</button>
          </div>
        </div>
      </div>
    </div>`,
  host: {
    class: 'hero-overlay'
  },
  standalone: true,
  imports: [],
})
export class HeroConfirmComponent {
  @Output() public accept = new EventEmitter();
  @Output() public deny = new EventEmitter();
}
